export enum ArchiveType {
    SUPPLIERCONTACT = 'SUPPLIERCONTACT',
    SUPPLIERCONTACTDETAIL = 'SUPPLIERCONTACTDETAIL',
    SUPPLIERCUSTOMER = 'SUPPLIERCUSTOMER',
    DELIVERYTERMSCONDITION = 'DELIVERYTERMSCONDITION',
    DELIVERYTERMSORDERDAY = 'DELIVERYTERMSORDERDAY',
    DELIVERYTERMSHOLIDAYS = 'DELIVERYTERMSHOLIDAYS',
    DELIVERYTERMSDELIVERYDAYS = 'DELIVERYTERMSDELIVERYDAYS'
};
